// 9fbef606107a605d69c0edbcd8029e5d

import { executeStatefulAPICall } from '../../handler';
import endpoints from '../../endpoints';

// Separate Stateful-Api endpoint is provided to make the address default
const defaultShippingAddressApi = (payload) => {
  const payloadData = {
    webService: endpoints.setDefaultPayment,
    header: {
      isRest: true,
      type: 'address',
      defaultAddressId: payload.addressId || '',
    },
  };

  return executeStatefulAPICall(payloadData)
    .then((res) => {
      if (!res) {
        throw new Error('res body is null');
        // TODO - Set API Helper to filter if error exists in response
      }
      return res?.body?.data?.c_shippingAddressId || '';
    })
    .catch((err) => {
      throw new Error(err);
    });
};
export default defaultShippingAddressApi;
